import {i18n} from '@netx/core/i18n';

const URL_REGEX =
	// eslint-disable-next-line security/detect-unsafe-regex
	/^(http|https|:\/\/|\.|@){2,}(localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|\S*:\w*@)*([a-zA-Z]|(\d{1,3}|\.){7}){1,}(\w|\.{2,}|\.[a-zA-Z]{2,3}|\/|\?|&|:\d|@|=|\/|\(.*\)|#|-|%)*$/;

export const url = (value: any) =>
	value == null || value === '' || URL_REGEX.test(value)
		? true
		: i18n.t('i18n.invalidValue');

export default url;
